import React, { PropsWithChildren, useContext } from 'react';

import { ConfigData, ConfigInterface, ConfigLinks } from './types';

const ConfigContext = React.createContext<ConfigInterface>(undefined);

export const ConfigProvider: React.FC<PropsWithChildren<{ config: ConfigInterface }>> = ({ config, children }) => (
    <ConfigContext.Provider value={config}>{children}</ConfigContext.Provider>
);

const useConfig = (): ConfigInterface => useContext(ConfigContext);

function maybeOr<T>(it: T, or: any = {}): T {
    return (it || or) as T;
}

function useConfigValue<Key extends keyof ConfigInterface>(key: Key): ConfigInterface[Key] {
    return maybeOr(useConfig())[key] as ConfigInterface[Key];
}

export function useData<Key extends keyof ConfigData>(key: Key): ConfigData[Key] {
    return maybeOr(useConfigValue('data'))[key];
}

export function useLink<Key extends keyof ConfigLinks>(key: Key): ConfigLinks[Key] {
    return maybeOr(useConfigValue('links'))[key];
}

export function useBankregnr(): ConfigInterface['bankregnr'] {
    return useConfigValue('bankregnr');
}
